import Image from 'next/image';
import React, { useState } from 'react';
import styled from 'styled-components';
import SwiperClass, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperButtonNext from '../../../../swiper/SwiperButtonNext';
import SwiperButtonPrev from '../../../../swiper/SwiperButtonPrev';

interface IImageSwiper {
  setSwiper: React.Dispatch<React.SetStateAction<SwiperClass | null>>;
  images: string[];
}

const SwiperPost = styled(Swiper)({
  width: '100%',
  '.swiper-slide': {
    flexShrink: 0,
    display: 'block',
    height: '100%',
    maxHeight: '100%',
    width: '100% !important',
  },
  '.swiper-wrapper': {
    maxHeight: '100%',
    height: '100%',
    display: 'flex',
  },
  '.swiper-pagination-bullet-active': { backgroundColor: '#009CE0' },
});

/* eslint-disable @next/next/no-img-element */
const ImageSwiper = ({ images, setSwiper }: IImageSwiper) => {
  const dynamicBulletCondition = images && images.length > 5;
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <SwiperPost
      navigation={true}
      modules={[Pagination, Navigation]}
      spaceBetween={0}
      slidesPerView={1}
      watchSlidesProgress={true}
      className="relative"
      pagination={{
        dynamicBullets: dynamicBulletCondition,
        dynamicMainBullets: 3,
        clickable: true,
      }}
      onRealIndexChange={(slide) => {
        setCurrentIndex(slide.realIndex);
      }}
      onSwiper={(swiper) => setSwiper(swiper)}
    >
      {images?.length > 1 && currentIndex > 0 && (
        <SwiperButtonPrev className="absolute top-[45%] left-2 z-[30] drop-shadow-sm">
          <Image
            className="opacity-75 hover:opacity-100"
            src="/icons/back-circle-filled.svg"
            alt="back button"
            width={40}
            height={40}
          />
        </SwiperButtonPrev>
      )}

      {images
        ? images.map((item, index) => {
            return (
              <SwiperSlide
                className="not-custom flex justify-center items-center my-auto pb-7"
                key={`slider-profile-${index}`}
              >
                <img
                  src={item}
                  alt="post image"
                  className="object-contain"
                  style={{
                    width: '100%',
                    maxHeight: '327px',
                  }}
                />
              </SwiperSlide>
            );
          })
        : null}
      {images?.length > 1 && currentIndex < images?.length - 1 && (
        <SwiperButtonNext className="absolute top-[45%] right-2 z-[30] drop-shadow-sm">
          <Image
            className="opacity-75 hover:opacity-100"
            src="/icons/forward-circle-filled.svg"
            alt="back button"
            width={40}
            height={40}
          />
        </SwiperButtonNext>
      )}
    </SwiperPost>
  );
};

export default ImageSwiper;
